// extracted by css-extract-rspack-plugin
export default {"grid":"grid--lvdZiY5BZGkNt6wO","scrollableWrapper":"scrollable-wrapper--guSJ0qWIWg2jTvqr"};